import * as React from 'react';
import {cn} from 'src/lib/utils';
import {usePopoverMenuContext} from 'src/PopoverMenuContext';

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & {
  onSelect?: () => void;
  iconLeft?: React.ReactNode;
};

const PopoverMenuItem = (props: Props) => {
  const {closeMenu} = usePopoverMenuContext();
  const {onClick, onSelect, disabled, children, iconLeft, className, ...rest} =
    props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    if (event.defaultPrevented || disabled) {
      return;
    }

    closeMenu();
    onSelect?.();
  };

  return (
    <button
      className={cn(
        'hover:bg-accent/50 flex w-full cursor-pointer',
        'flex-row items-center justify-start gap-3 py-2 pr-10 pl-2',
        'disabled:text-muted-foreground disabled:cursor-auto disabled:hover:bg-transparent',
        className,
      )}
      {...rest}
      type="button"
      role="menuitem"
      onClick={handleClick}
      disabled={disabled}
    >
      <div className="size-3.5 [&>svg]:size-full">{iconLeft}</div>
      {children}
    </button>
  );
};

export default PopoverMenuItem;
